import React, { ReactElement } from 'react'
import * as uuid from 'uuid'
type PropsType = {
  size: number
}

const Loader = (props: PropsType): ReactElement => {
  const { size } = props
  const setID = uuid.v4()
  return (
    <div style={{ height: `${size}px`, width: `${size}px` }}>
      <svg viewBox="0 0 128 128">
        <g height={'100%'} width={'100%'}>
          <linearGradient id={setID}>
            <stop fillOpacity="0" offset="0%" stopColor="#fff" />
            <stop offset="100%" stopColor="#e13000" />
          </linearGradient>
          <path
            fill={`url(#${setID})`}
            fillRule="evenodd"
            d="M63.85 0A63.85 63.85 0 110 63.85 63.85 63.85 0 0163.85 0zm.65 19.5a44 44 0 11-44 44 44 44 0 0144-44z"
          />
          <animateTransform
            attributeName="transform"
            dur="1320ms"
            from="0 64 64"
            repeatCount="indefinite"
            to="360 64 64"
            type="rotate"
          />
        </g>
      </svg>
    </div>
  )
}

Loader.defaultProps = {
  size: 40,
}

export default Loader
